import styled from "styled-components";

export const Options = styled("ul")<{ isLabelGiven: boolean }>`
    z-index: 4;
    position: absolute;
    background: #fff;
    border: 1px solid transparent;
    top: ${({ isLabelGiven }) => (isLabelGiven ? "68px" : "50px")};

    left: 0;
    margin: 0;
    padding: 0;
    max-width: 15rem;
    width: 100%;
    list-style: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: rgb(176 188 200) 0px 2px 5px;
    max-height: 200px;
    overflow: auto;
`;
